module.exports = __webpack_public_path__ + "img/Vectorleft_disabled.87e7ed90.svg";